import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/labels";

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = useCallback(() => api.get("/customer/notifications").then((r) => setData(r.data)).catch(() => {}), []);

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);

  const onOpen = (open) => {
    if (open && data.unread) {
      api.post("/customer/notifications/read-all").then(() => setTimeout(load, 4000)).catch(() => {});
    }
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className="relative grid h-10 w-10 place-items-center rounded-2xl border border-purple-500/30 bg-[var(--km-card)] text-white hover:bg-[var(--km-purple)]" aria-label="الإشعارات" data-testid="notification-bell">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span className="absolute -left-1 -top-1 grid h-6 min-w-6 place-items-center rounded-full bg-[var(--km-pink)] px-1 text-xs font-bold text-white" data-testid="notification-unread-count">{data.unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" dir="rtl" className="w-[min(92vw,380px)] border-purple-500/30 bg-[var(--km-bg2)] p-0 text-white" data-testid="notification-panel">
        <p className="font-head border-b border-purple-500/20 px-4 py-3 font-bold">الإشعارات</p>
        <div className="max-h-[60vh] overflow-y-auto">
          {data.items.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-purple-300/70" data-testid="notifications-empty">مفيش إشعارات لسه</p>
          ) : data.items.map((n, i) => (
            <Link key={n.id} to={n.link || "/account"} className={`block border-b border-purple-500/10 px-4 py-3 hover:bg-white/5 ${n.read ? "" : "bg-[var(--km-purple)]/15"}`} data-testid={`notification-item-${i}`}>
              <span className="flex items-start gap-2">
                {!n.read && <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[var(--km-pink)]" />}
                <span>
                  <span className="font-head block text-sm font-bold">{n.title}</span>
                  <span className="block whitespace-pre-wrap text-xs text-purple-200/80">{n.body}</span>
                  <span className="mt-1 block text-[11px] text-purple-300/60">{fmtDate(n.created_at)}</span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
